import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import {
	DocumentsOfMultipleObjectsView,
	DocumentsOfMultipleObjectsViewProps,
} from "src/components/views/documents/objectDocuments/DocumentsOfMultipleObjectsView.tsx";
import { ShopOrderApi } from "src/api/generated/erp/production/api/shopOrder/shopOrderApi.ts";
import {
	getShopOrderDocumentObjectRefs,
} from "src/components/views/erp/production/shopOrder/shopOrderDocumentRefs.ts";

export interface ShopOrdersExtendedDocumentsViewProps
	extends Omit<DocumentsOfMultipleObjectsViewProps, "objectRefs" | "editable"> {
	shopOrderIds: number[];
}

/**
 * View for displaying documents of all documents of multiple shop orders.
 * For each shop order, the documents of the shop order, part, customer order, and customer order line are displayed.
 */
export const ShopOrdersExtendedDocumentsView = ({ shopOrderIds, ...other }: ShopOrdersExtendedDocumentsViewProps) => {
	return (
		<AsyncFetchRender
			fetch={() => ShopOrderApi.getShopOrders({ shopOrderIds })}
			content={(shopOrders) => {
				return (
					<DocumentsOfMultipleObjectsView
						objectRefs={shopOrders.flatMap((shopOrder) => getShopOrderDocumentObjectRefs(shopOrder))}
						editable={false}
						{...other}
					/>
				);
			}}
		/>
	);
};
